/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-30 16:24:58
 * @LastEditTime: 2020-09-27 09:39:42
 * @Description: 销售订单评论
 */
import {
    getSalesOrderCommentList,
    createSalesOrderComment,
    updateSalesOrderComment
} from '@/api/salesOrderComment'
import Vue from 'vue'

const state = {
    salesOrderCommentList: [],
}

const actions = {
    async getSalesOrderCommentListAction({
        commit
    }, payload) {
        try {
            const salesOrderCommentList = await getSalesOrderCommentList(payload);
            commit('SETSALESORDERCOMMENTLIST', salesOrderCommentList.data)
        } catch (error) {
            throw error.message
        }
    },
    async createSalesOrderCommentAction({
        commit
    }, payload) {
        try {
            const newSalesOrderComment = await createSalesOrderComment(payload);
            commit('ADDNEWSALESORDERCOMMENT', newSalesOrderComment.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateSalesOrderCommentAction({
        commit
    }, payload) {
        try {
            const newcSalesOrderComment = await updateSalesOrderComment(payload.id, payload.data)
            commit('UPDATESALESORDERCOMMENT', newcSalesOrderComment.data)
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
    SETSALESORDERCOMMENTLIST(state, payload) {
        state.salesOrderCommentList = payload;
        state.totalCounts = payload.totalCounts
    },
    ADDNEWSALESORDERCOMMENT(state, salesOrderComment) {
        state.salesOrderCommentList.unshift(salesOrderComment)
    },
    UPDATESALESORDERCOMMENT(state, SalesOrderComment) {
        Vue.set(state.salesOrderCommentList, state.salesOrderCommentList.findIndex(x => x._id === SalesOrderComment._id), SalesOrderComment)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}